export const requiredEnvVars = [
  "VITE_EURO_MYRON_ADDRESS",
  "VITE_RPC_URL",
  "VITE_BACKEND_URL",
  "VITE_POLYGON_SCAN",
  "VITE_MYRON_IBAN",
  "VITE_MYRON_BIC",
  "VITE_MYRON_RECIPIENT"
];
